/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import GenericTable from "../../components/GenericTable";
import TableLineIcons from "../../components/TableLineIcons";
import { Button, Checkbox, Form, Input, InputNumber, Select } from "antd";
import GenericSelector from "../../components/GenericSelector";
import TableIDs from "../../data/TableIDs";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import DateTimePicker from "../../components/DateTimePicker";
import GenericModal from "../../components/GenericModal";
import SelectorItemsMulti from "../../components/SelectorItemsMulti";
import moment from "moment";

class BITargets extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {

        };

        this.id = "BI_TARGETS";

        this.api = {
            get: "get_bi_targets",
            edit: "edit_bi_targets",
            create: "create_bi_targets",
        }

        this.selectors = [
            { id: TableIDs.genericSelectorEmployees, api: "get_employee_list" },
            { id: TableIDs.genericSelectorBranches, api: "get_branch_list" }
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        this.selectors.forEach(x => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } })

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(20887);
    }

    getTypeName = (id) => {
        switch (id) {
            case '1': return this.getText(20899)
            case '2': return this.getText(20900)
        }
    }

    getValTypeName = (id) => {
        switch (id) {
            case '1': return this.getText(20901)
            case '2': return this.getText(20902)
            case '3': return this.getText(20903)
        }
    }

    renderEditCol = (text, record) => {
        return (<TableLineIcons onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index) }} />)
    }

    handleCancel = () => {
        if (this.props.data[this.id].editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id);
        else this.props.dataActions.genericDataCancelEditing(this.id);
    }

    handleOk = () => {
        const { editing } = this.props.data[this.id]
        this.props.dataActions.genericDataSaveEdit(
            this.id, this.props.user.companyCode, this.props.user.token,
            editing == 0 ? this.api.create : this.api.edit,
            this.api.get);
    }

    getField = (field) => {
        const { editedRecord } = this.props.data[this.id]
        const value = editedRecord[field]
        const onChange = e => { this.props.dataActions.genericDataSetEdit(this.id, { [field]: e }) }

        switch (field) {

            case 'tDesc':
                return (<Input value={value} onChange={e => { onChange(e.target.value) }} />)

            case 'tType': case 'tValType':
                let optionList = field == 'tType' ?
                    ['1', '2'].map(x => (<Select.Option value={x}>{x} - {this.getTypeName(x)}</Select.Option>))
                    : ['1', '2', '3'].map(x => (<Select.Option value={x}>{x} - {this.getValTypeName(x)}</Select.Option>))
                return (<Select style={{ width: 300 }} {...{ value, onChange }}>{optionList}</Select>)

            case 'tBranchList': case 'tWorkerList':
                return (<GenericSelector {...this.props} multi
                    {...this.selectors[field == 'tBranchList' ? 1 : 0]}
                    value={value ? value.split(",") : []}
                    onChange={e => { onChange(e ? e.join(",") : "") }} />)

            case 'tDay': case 'tWeek': case 'tMonth': case 'tYear':
                return (<InputNumber {...{ value, onChange }} />)

            case 'tItemCode':
                return (<SelectorItemsMulti {...this.props}
                    value={value ? value.split(",") : []}
                    onChange={e => { onChange(e ? e.map(x => x.mCode).join(",") : "") }} />)

            case 'tIncTags': case 'tExcTags':
                return (<GenericSelectorItemTags {...this.props} multi
                    value={value ? value.split(",") : []}
                    onChange={e => {
                        this.props.dataActions.genericDataSetEdit(this.id, {
                            tIncTags: field == 'tIncTags' ? e ? e.join(",") : "" : "",
                            tExcTags: field == 'tExcTags' ? e ? e.join(",") : "" : ""
                        })
                    }} />)

            case 'tFromDate': case 'tToDate':
                return (<DateTimePicker format="DD/MM/YYYY" {...{ value, onChange }}
                    minDate={field == 'tToDate' ? editedRecord.tFromDate : null}
                    maxDate={field == 'tFromDate' ? editedRecord.tToDate : null}
                />)

            case 'tIsActive':
                return (<Checkbox checked={value == 1} onChange={e => { onChange(e.target.checked ? '1' : '0') }}>{this.getText(20897)}</Checkbox>)

        }
    }

    getFormItem = (label, field) => {
        return (<Form.Item label={label}>{this.getField(field)}</Form.Item>)
    }

    render() {
        const gt = this.getText;
        const render = t => t
        const renderCB = t => (<Checkbox checked={t == 1} />)
        const renderDate = t => t ? moment(t).format("DD/MM/YYYY") : ""
        const sorter = true;
        const { editing, editedRecord } = this.props.data[this.id]

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: "ltr"
            padding: "2% 2% 2% 2%",
        };

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                rowsFilter={r => r.key > 0}
                id={this.id}
                getApi={this.api.get}
                title={gt(20888)}
                addButton={() => { this.props.dataActions.genericDataStartInlineCreate(this.id) }}
                columns={[
                    { title: gt(20889), key: "tID", dataIndex: "tID", width: "5%", render, sorter },
                    { title: gt(20890), key: "tDesc", dataIndex: "tDesc", width: "17%", render, sorter },
                    { title: gt(20891), key: "tType", dataIndex: "tType", width: "8%", render: this.getTypeName, sorter },
                    { title: gt(20892), key: "tValType", dataIndex: "tValType", width: "8%", render: this.getValTypeName, sorter },
                    { title: gt(20893), key: "tDay", dataIndex: "tDay", width: "8%", render, sorter },
                    { title: gt(20894), key: "tWeek", dataIndex: "tWeek", width: "8%", render, sorter },
                    { title: gt(20895), key: "tMonth", dataIndex: "tMonth", width: "8%", render, sorter },
                    { title: gt(20896), key: "tYear", dataIndex: "tYear", width: "8%", render, sorter },
                    { title: gt(22877), key: "tFromDate", dataIndex: "tFromDate", width: "8%", render: renderDate, sorter },
                    { title: gt(22878), key: "tToDate", dataIndex: "tToDate", width: "8%", render: renderDate, sorter },
                    { title: gt(20897), key: "tIsActive", dataIndex: "tIsActive", width: "5%", render: renderCB, sorter },
                    { title: gt(20898), width: "5%", render: this.renderEditCol },

                ]}
            />

            <GenericModal
                visible={editing > -1}
                onCancel={this.handleCancel}
                title={editing == 0 ? gt(20904) : `${gt(20905)} ${editedRecord?.tID}`}
                width={1000}
                footer={[
                    <Button key={"back"} onClick={this.handleCancel} style={{ margin: 5 }}>{gt(20906)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleOk} style={{ margin: 5 }}>{gt(20907)}</Button>,
                ]}>
                <Form style={{ columnWidth: 'auto', columnCount: window.innerWidth > 600 ? '2' : '1' }}>
                    {this.getFormItem(gt(20890), 'tDesc')}
                    {this.getFormItem(gt(20891), 'tType')}
                    {this.getFormItem(gt(20892), 'tValType')}
                    {this.getFormItem(gt(20893), 'tDay')}
                    {this.getFormItem(gt(20894), 'tWeek')}
                    {this.getFormItem(gt(20895), 'tMonth')}
                    {this.getFormItem(gt(20896), 'tYear')}
                    {this.getFormItem(null, 'tIsActive')}
                    {this.getFormItem(gt(20908), 'tBranchList')}
                    {this.getFormItem(gt(20909), 'tWorkerList')}
                    {this.getFormItem(gt(20910), 'tItemCode')}
                    {this.getFormItem(gt(20911), 'tIncTags')}
                    {this.getFormItem(gt(20912), 'tExcTags')}
                    {this.getFormItem(gt(20913), 'tFromDate')}
                    {this.getFormItem(gt(20914), 'tToDate')}
                </Form>
            </GenericModal>
        </div>)
    }

}

export default BITargets;